import { useFeatureToggles } from '@grandvisionhq/state';

/**
 * This hook can be used to check if additional login providers (apple, google) are set in the OpCo.
 * For example within "social login" to check if 'google' login should be enabled.
 */ function useAdditionalLoginProviders() {
    const { featureConfigs  } = useFeatureToggles();
    const { additionalLoginProviders  } = featureConfigs // [google, apple, etc]
    ;
    const isProviderEnabled = (provider)=>{
        return !!(additionalLoginProviders === null || additionalLoginProviders === void 0 ? void 0 : additionalLoginProviders.includes(provider));
    };
    return {
        hasProviders: !!(additionalLoginProviders === null || additionalLoginProviders === void 0 ? void 0 : additionalLoginProviders.length),
        isProviderEnabled
    };
}

export { useAdditionalLoginProviders };
//# sourceMappingURL=use-additional-login-providers.js.map
